import { getWidgetTypeColorKey } from '../../constants/widgetTypes'
import styles from './widgetTypeColors.module.scss'

/**
 * The class that puts a widget type's color family on an element, as the
 * `--widget-type-*` custom properties. Returns '' for an unrecognised type, so
 * anything styled from those properties has to carry its own fallback.
 */
export const widgetTypeColorClass = (code: string): string => {
  const key = getWidgetTypeColorKey(code)
  return key ? styles[`type-${key}`] : ''
}
